import { ChangeDetectionStrategy, Component, computed, effect, inject } from '@angular/core';
import { Router } from '@angular/router';
import { APP_PATHS } from '../../../../../core/config/app-paths';
import { Tab, TabList, TabPanel, TabPanels, Tabs } from 'primeng/tabs';
import { AdminPanelUserDetailsComponent } from './components/admin-panel-user-details/admin-panel-user-details.component';
import { AdminPanelUserCorrespondenceTableComponent } from './components/admin-panel-user-correspondence-table/admin-panel-user-correspondence-table.component';
import { AdminPanelUserEventsHistoryTableComponent } from './components/admin-panel-user-events-history-table/admin-panel-user-events-history-table.component';
import { AdminPanelUserPreviewStateService } from '../../state/admin-panel-user-preview-state.service';

@Component({
  selector: 'app-admin-panel-user-preview',
  imports: [
    AdminPanelUserCorrespondenceTableComponent,
    AdminPanelUserDetailsComponent,
    AdminPanelUserEventsHistoryTableComponent,
    Tab,
    TabList,
    TabPanel,
    TabPanels,
    Tabs,
  ],
  templateUrl: './admin-panel-user-preview.html',
  styleUrl: './admin-panel-user-preview.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminPanelUserPreview {
  readonly #userPreviewState = inject(AdminPanelUserPreviewStateService);
  readonly #router = inject(Router);
  protected readonly selectedUser = computed(() =>
    this.#userPreviewState.selectedUser(),
  );

  constructor() {
    effect(() => {
      if (this.selectedUser() === null) {
        void this.#router.navigate([
          `/${APP_PATHS.admin.root}/${APP_PATHS.admin.users}`,
        ]);
      }
    });
  }
}
